{
  "#CHECKLISTE": {
    "MODULE_TITLE": "Aufgaben",
    "COUNT": {
      "ONE": "{{count}} Checkliste",
      "MANY": "{{count}} Checklisten"
    },
    "DIALOGS": {
      "CREATE": {
        "TITLE": "Aufgabe erstellen",
        "SUCCESS": "Die Aufgabe wurde erfolgreich erstellt"
      }
    },
    "CHECKLISTEN": {
      "ADD": "Erstellen"
    }
  }
}
